export const timeout = 5000;
export const SUCCESS_CODE = 0;
export const INFO_BASE_URL = process.env.VUE_APP_INFO_API_BASE_URL;
export const COMMENT_BASE_URL = process.env.VUE_APP_COMMENT_API_BASE_URL;
export const isClient = typeof window !== 'undefined';
